import { render, staticRenderFns } from "./importCmp.vue?vue&type=template&id=0d6e3600&"
import script from "./importCmp.vue?vue&type=script&lang=ts&"
export * from "./importCmp.vue?vue&type=script&lang=ts&"
import style0 from "./importCmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports